<template>
  <div>
    <HearderTitle :name="title" />
    <div class="personnelFrom">
      <el-form ref="personnelFrom" :rules="rules" :model="personnelFrom" label-width="110px" :inline="true" size="small">
        <p class="title">个人信息<i @click="changeShow('section1', 'segmentation1')" class="el-icon-arrow-down cursor" style="float: right"></i></p>
        <section v-show="section1">
          <el-form-item label="姓名" prop="pername">
            <el-input v-model="personnelFrom.pername"></el-input>
          </el-form-item>
          <el-form-item label="照片" class="photo" prop="photo">
            <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handlePhotoSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="personnelFrom.photo" :src="personnelFrom.photo" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item label="联系方式" prop="contact" style="padding-left: 70px">
            <el-input v-model="personnelFrom.contact"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="personnelFrom.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="其他联系方式" prop="othercontact" style="padding-left: 70px">
            <el-input v-model="personnelFrom.othercontact"></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="cardid">
            <el-input @blur="chenge(personnelFrom.cardid)" v-model="personnelFrom.cardid"></el-input>
          </el-form-item>
          <el-form-item label="生日" prop="birthday">
            <el-date-picker v-model="personnelFrom.birthday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
          </el-form-item>
          <el-form-item label="户籍" prop="province">
            <el-input v-model="personnelFrom.province"></el-input>
          </el-form-item>
          <el-form-item label="户籍所在地" prop="address">
            <el-input v-model="personnelFrom.address"></el-input>
          </el-form-item>
          <el-form-item label="民族" prop="nation">
            <el-input v-model="personnelFrom.nation"></el-input>
          </el-form-item>
          <el-form-item label="政治面貌" prop="organ">
            <el-input v-model="personnelFrom.organ"></el-input>
          </el-form-item>
          <el-form-item label="学校" prop="school">
            <el-input v-model="personnelFrom.school"></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="edu">
            <el-input v-model="personnelFrom.edu"></el-input>
          </el-form-item>
          <el-form-item label="专业" prop="manjor">
            <el-input v-model="personnelFrom.manjor"></el-input>
          </el-form-item>
          <el-form-item label="婚姻状态" prop="marrage">
            <el-radio-group v-model="personnelFrom.marrage">
              <el-radio label="未婚"></el-radio>
              <el-radio label="已婚"></el-radio>
            </el-radio-group>
          </el-form-item>
          <div></div>
        </section>
        <section class="segmentation" v-show="segmentation1"></section>
        <p class="title">入职信息<i @click="changeShow('section2', 'segmentation2')" class="el-icon-arrow-down cursor" style="float: right"></i></p>
        <section v-show="section2">
          <el-form-item label="所属部门" prop="dep_id">
            <el-select v-model="personnelFrom.dep_id" placeholder="请选择" ref="selectTree" @change="changeDep(personnelFrom.dep_id)">
              <el-option v-for="item in datalist" :key="item.id" :value="item.name" :label="item.name"> </el-option>
              <!-- <el-tree :data="datalist" :props="defaultProps" @node-click="handleClickNode" :default-expand-all="true" node-key="id"></el-tree> -->
            </el-select>
          </el-form-item>
          <el-form-item label="职务" prop="roles">
            <el-select v-model="personnelFrom.roles" placeholder="请选择">
              <el-option v-for="item in childrenData" :key="item.id" :value="item.name" :label="item.name"> </el-option>

              <!-- <el-tree :data="datalist" :props="defaultProps" @node-click="handleClickNode" :default-expand-all="true" node-key="id"></el-tree> -->
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间" prop="inday">
            <el-date-picker v-model="personnelFrom.inday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" prop="stu">
            <el-select v-model="personnelFrom.stu" clearable>
              <el-option label="试岗期" :value="1"></el-option>
              <el-option label="试用期" :value="2"></el-option>
              <el-option label="正式员工" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="转正时间" prop="trial_period_end">
            <el-date-picker v-model="personnelFrom.trial_period_end" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
          </el-form-item>
          <el-form-item label="签合年限" prop="pactyear">
            <el-input v-model="personnelFrom.pactyear"></el-input>
          </el-form-item>
          <el-form-item label="合同到期时间" prop="endpactday">
            <el-date-picker v-model="personnelFrom.endpactday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
          </el-form-item>
          <el-form-item label="上次合同时间" prop="prepactday">
            <el-date-picker v-model="personnelFrom.prepactday" prefix-icon=" " format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"> </el-date-picker>
          </el-form-item>
          <el-form-item label="签合同次数" prop="pactnum">
            <el-input v-model="personnelFrom.pactnum"></el-input>
          </el-form-item>
          <div></div>
        </section>
        <section class="segmentation" v-show="segmentation2"></section>
        <p class="title">简历图片<i @click="changeShow('section3', 'segmentation3')" class="el-icon-arrow-down cursor" style="float: right"></i></p>
        <section v-show="section3">
          <el-form-item label="备注" class="record" prop="moreinfo ">
            <el-input class="moreinfo" v-model="personnelFrom.moreinfo"></el-input>
          </el-form-item>
          <el-form-item class="upload3 upload2 pics" label="简历上传" prop="pics">
            <!-- <el-input class="moreinfo" :limit="1" readonly v-model="personnelFrom.pics"> </el-input> -->
            <!-- <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"> 上传 <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload> -->
            <el-upload class="annaul-ticket-imgs" :on-change="handleEditChange" :class="{ 'hide-upload-btn': hideUploadBtn }" :action="uploadUrl" :limit="6" list-type="picture-card" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove0" :file-list="record_file_list0">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item class="upload record" label="上传照片" prop="perzp">
            <el-input class="moreinfo" readonly v-model="personnelFrom.perzp"> </el-input>
            <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handlePerzpSuccess" :before-upload="beforeAvatarUpload"> 上传 <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload>
          </el-form-item>
          <div></div>
        </section>
        <section class="segmentation" v-show="segmentation3"></section>
        <section v-if="isShowRecord">
          <p class="title">面谈记录 <i @click="changeShow('section4', 'segmentation4')" class="el-icon-arrow-down cursor" style="float: right"></i></p>
          <section v-show="section4">
            <el-form-item label="试岗/满月面谈" class="record" prop="record1">
              <el-input class="moreinfo" type="textarea" v-model="personnelFrom.record1"></el-input>
            </el-form-item>
            <el-form-item class="upload2" prop="record_pic1">
              <el-upload class="annaul-ticket-imgs" :on-change="handleEditChange" :class="{ 'hide-upload-btn': hideUploadBtn }" :action="uploadUrl" :limit="6" list-type="picture-card" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove2" :file-list="record_file_list1">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="转正面谈" class="record" prop="record2">
              <el-input class="moreinfo" type="textarea" v-model="personnelFrom.record2"></el-input>
            </el-form-item>
            <el-form-item class="upload2" prop="record_pic2">
              <el-upload class="annaul-ticket-imgs" :on-change="handleEditChange" :class="{ 'hide-upload-btn': hideUploadBtn }" :action="uploadUrl" :limit="6" list-type="picture-card" :on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove3" :file-list="record_file_list2">
                <!--  -->
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="离职面谈" class="record" prop="record3">
              <el-input class="moreinfo" type="textarea" v-model="personnelFrom.record3"></el-input>
            </el-form-item>
            <el-form-item class="upload2" prop="record_pic3">
              <el-upload class="annaul-ticket-imgs" :on-change="handleEditChange" :class="{ 'hide-upload-btn': hideUploadBtn }" :action="uploadUrl" :limit="6" list-type="picture-card" :on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove4" :file-list="record_file_list3">
                <!-- :file-list="recordpic(personnelFrom.record_pic3)" -->
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <div></div>
          </section>
        </section>
        <section class="segmentation" v-show="segmentation4"></section>
        <el-form-item>
          <el-button class="lightBlueBtn" type="primary" size="small" @click="seve()">提交</el-button>
          <el-button plain size="small" @click="$refs['personnelFrom'].resetFields()">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { getDepList } from '@/api/common.js'
  import { addPersonnel, editPersonnel, getPersonnelInfoById } from '@/api/personnelList.js'
  import HearderTitle from '@/components/HearderTitle'
  import { getUserInfoByidNumber } from '@/util/index.js'
  export default {
    data() {
      return {
        personnelFrom: {
          record1: '',
          record_pic1: '',
          record2: '',
          record_pic2: '',
          record3: '',
          record_pic3: '',
          pername: '',
          sex: '',
          contact: '',
          othercontact: '',
          cardid: '',
          birthday: '',
          province: '',
          address: '',
          nation: '',
          organ: '',
          school: '',
          edu: '',
          manjor: '',
          marrage: '',
          dep_id: '',
          roles: '',
          inday: '',
          stu: null,
          pactyear: null,
          // trial_days: 60,
          endpactday: '',
          prepactday: '',
          pactnum: '',
          moreinfo: '',
          pics: '',
          perzp: '',
          trial_period_end: null,
          photo: '',
        },
        datalist: [],
        depList: [],
        defaultProps: {
          children: 'children',
          label: 'name',
        },
        rules: {
          pername: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
          sex: [{ required: true, message: '性别不能为空', trigger: 'blur' }],
          contact: [
            { required: true, message: '联系方式不能为空', trigger: 'blur' },
            { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' },
          ],
          // trial_period_end: [{ required: true, message: '试用时间不能为空', trigger: 'blur' }],
          cardid: [
            { required: true, message: '身份证不能为空', trigger: 'blur' },
            { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '请输入正确的身份证号', trigger: 'blur' },
          ],
          birthday: [{ required: true, message: '生日不能为空', trigger: 'blur' }],
          province: [{ required: true, message: '户籍不能为空', trigger: 'blur' }],
          address: [{ required: true, message: '户籍所在地不能为空', trigger: 'blur' }],
          nation: [{ required: true, message: '民族不能为空', trigger: 'blur' }],
          school: [{ required: true, message: '学校不能为空', trigger: 'blur' }],
          edu: [{ required: true, message: '学历不能为空', trigger: 'blur' }],
          manjor: [{ required: true, message: '专业不能为空', trigger: 'blur' }],
          marrage: [{ required: true, message: '婚姻状态不能为空', trigger: 'blur' }],
          dep_id: [{ required: true, message: '所属部门不能为空', trigger: 'blur' }],
          roles: [{ required: true, message: '职务不能为空', trigger: 'blur' }],
          inday: [{ required: true, message: '入职时间不能为空', trigger: 'blur' }],
          stu: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
          pactyear: [{ required: true, message: '签合年限不能为空', trigger: 'blur' }],
          pactnum: [{ required: true, message: '签合同次数不能为空', trigger: 'blur' }],
        },
        uploadUrl: '',
        title: '',
        childrenData: [],
        personnelInfo: {},
        id: '',
        dialogImageUrl: '',
        dialogVisible: false,
        hideUploadBtn: false,
        record_file_list0: [],
        record_file_list1: [],
        record_file_list2: [],
        record_file_list3: [],
        section1: true,
        section2: true,
        section3: true,
        section4: true,
        segmentation1: false,
        segmentation2: false,
        segmentation3: false,
        segmentation4: false,
        isShowRecord: false,
      }
    },
    async created() {
      let { data } = await getDepList()
      this.depList = data
      data.forEach((v) => {
        if (v.pid === 0) {
          this.datalist.push(v)
        }
      })

      // 获取上传url
      this.uploadUrl = process.env.VUE_APP_API_URL + '/mypub/loaddail?ty=hr'
      // 获取编辑页面id
      if (this.$route.name === 'editPersonnel') {
        this.title = '编辑人员'
        let id = ''
        if (this.$route.params.id) {
          id = this.$route.params.id
          sessionStorage.setItem('personneId', id)
          // 获取修改数据索引并保存
          sessionStorage.setItem('editDataIndex', this.$route.params.index)
        } else {
          id = JSON.parse(sessionStorage.getItem('personneId'))
        }
        this.id = id
        this.getPersonnelInfoById(id)
        this.isShowRecord = true
      } else {
        this.title = '添加人员'
      }
    },
    methods: {
      // //节点点击事件
      // handleClickNode(data) {
      //   this.personnelFrom.dep_id = data.name
      //   // 选择器执行完成后，使其失去焦点隐藏下拉框的效果
      //   this.$refs.selectTree.blur()
      // },
      changeDep(val) {
        this.personnelFrom.roles = ''
        this.depList.forEach((v) => {
          if (val == v.name) {
            this.childrenData = v.children
          }
        })
      },
      changeShow(val, val2) {
        this[val] = !this[val]
        this[val2] = !this[val2]
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      },

      handleEditChange(file, fileList) {
        this.hideUploadBtn = fileList.length >= 6
      },
      handleRemove0(file, fileList) {
        let removeUrl = file.url
        let pics = this.personnelFrom.pics.split(',').filter((v, index) => {
          if (v.indexOf(removeUrl) === -1) return v
        })
        this.personnelFrom.pics = pics.join(',')
        this.hideUploadBtn = fileList.length >= 6
      },
      handleRemove2(file, fileList) {
        let removeUrl = file.url
        let record_pic1 = this.personnelFrom.record_pic1.split(',').filter((v, index) => {
          if (v.indexOf(removeUrl) === -1) return v
        })
        this.personnelFrom.record_pic1 = record_pic1.join(',')
        this.hideUploadBtn = fileList.length >= 6
      },
      handleRemove3(file, fileList) {
        let removeUrl = file.url
        let record_pic1 = this.personnelFrom.record_pic2.split(',').filter((v, index) => {
          if (v.indexOf(removeUrl) === -1) return v
        })
        this.personnelFrom.record_pic2 = record_pic1.join(',')
        this.hideUploadBtn = fileList.length >= 6
      },
      handleRemove4(file, fileList) {
        let removeUrl = file.url
        let record_pic1 = this.personnelFrom.record_pic3.split(',').filter((v, index) => {
          if (v.indexOf(removeUrl) === -1) return v
        })
        this.personnelFrom.record_pic3 = record_pic1.join(',')
        this.hideUploadBtn = fileList.length >= 6
      },
      // 上传图片
      handleAvatarSuccess2(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        console.log(this.personnelFrom.record_pic1)
        let len = this.personnelFrom.record_pic1.length
        if (len === 0) {
          this.personnelFrom.record_pic1 += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.personnelFrom.record_pic1 += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      // 上传图片
      handleAvatarSuccess3(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        let len = this.personnelFrom.record_pic2.length
        if (len === 0) {
          this.personnelFrom.record_pic2 += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.personnelFrom.record_pic2 += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      // 上传图片
      handleAvatarSuccess4(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        let len = this.personnelFrom.record_pic3.length
        if (len === 0) {
          this.personnelFrom.record_pic3 += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.personnelFrom.record_pic3 += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      // 提交
      async seve() {
        this.$refs['personnelFrom'].validate(async (valid) => {
          if (!valid) return
          let res = {}
          if (this.id !== '') {
            let data = { id: this.id, ...this.personnelFrom }
            res = await editPersonnel(data)
            // 缓存修改的数据
            sessionStorage.setItem('editData', JSON.stringify(data))
          } else {
            res = await addPersonnel(this.personnelFrom)
          }
          if (res.status !== 200) return this.$message.error('提交失败')
          this.$message.success('提交成功')
          return this.$router.go(-1)
        })
      },
      // 根据id查询人员信息
      async getPersonnelInfoById(id) {
        let res = await getPersonnelInfoById({ id })
        this.personnelFrom = res.data
        this.record_file_list0 = this.file_list(this.personnelFrom.pics)
        this.record_file_list1 = this.file_list(this.personnelFrom.record_pic1)
        this.record_file_list2 = this.file_list(this.personnelFrom.record_pic2)
        this.record_file_list3 = this.file_list(this.personnelFrom.record_pic3)
      },
      file_list(val) {
        if (val === '' || !val) return []
        let arr = []
        val.split(',').forEach((v) => {
          arr.push({ url: v })
        })
        return arr
      },
      // 上传简历
      handleAvatarSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        let len = this.personnelFrom.pics.length
        if (len === 0) {
          this.personnelFrom.pics += 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        } else {
          this.personnelFrom.pics += ',http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        }
      },
      // 上传照片
      handlePhotoSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        this.personnelFrom.photo = 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
        console.log('this.personnelFrom.photo: ', this.personnelFrom.photo)
      },

      // 上传图片
      handlePerzpSuccess(res, file) {
        if (res.status !== 200) return this.$message.error('上传失败')
        this.$message.success('上传成功')
        this.personnelFrom.perzp = 'http://yjhr.oss-cn-shenzhen.aliyuncs.com/' + res.url
      },
      // 上传限制
      beforeAvatarUpload(file) {
        const isJPG = ['image/jpeg', 'image/png']
        const isLt5M = file.size / 1024 / 1024 < 6
        if (!isJPG.includes(file.type)) {
          this.$message.error('上传头像图片只能是JPG或PNG 格式!')
        }
        if (!isLt5M) {
          this.$message.error('上传头像图片大小不能超过 5MB!')
        }
        return isJPG.includes(file.type) && isLt5M
      },
      // 根据身份证号获取信息
      chenge(val) {
        if (!new RegExp(/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/).test(val)) return
        let { province, birthday, sex } = getUserInfoByidNumber(val)
        this.personnelFrom.sex = sex
        this.personnelFrom.birthday = birthday
        this.personnelFrom.province = province
      },
    },
    watch: {
      'personnelFrom.dep_id': function (val, oldVal) {
        console.log(val, oldVal)
        this.depList.forEach((v) => {
          if (val == v.name) {
            this.childrenData = v.children
          }
        })
      },
    },
    components: { HearderTitle },
  }
</script>

<style lang="less">
  .personnelFrom {
    margin: 0 auto;
    margin-top: 40px;
    width: 976px;
    .title {
      font-size: 14px;
      color: #666666;
      border-left: 3px solid #1f7ac3;
      height: 14px;
      padding-left: 5px;
      line-height: 14px;
      margin-bottom: 5px;
    }
    .segmentation {
      height: 1px;
      border-bottom: 1px solid #eee;
      margin: 15px 0 15px 0;
    }
    .el-form-item {
      .el-form-item__label {
        font-size: 12px;
      }
      padding-left: 70px;
      &:nth-of-type(2n) {
        padding-left: 40px;
      }
      &.pics {
        padding-left: 70px;
      }

      &.upload {
        position: relative;
        .avatar-uploader {
          background-color: #fff;
          position: absolute;
          right: 10px;
          top: 0;
          color: #b3b3b3;
          height: 30px;
          margin-top: 1px;
        }
      }
      &.upload2 {
        padding-left: 180px;
        margin-bottom: 28px;
        .annaul-ticket-imgs {
          ul {
            overflow: hidden;
            line-height: 0;
            li {
              margin-bottom: 0;
            }
          }
          &.hide-upload-btn {
            .el-upload--picture-card {
              display: none;
            }
          }
        }
        .el-upload--picture-card {
          line-height: 110px;
        }
        .el-upload-list__item-status-label {
          background-color: #1f7ac3;
          width: 36px;
          height: 22px;
        }
        .el-upload.el-upload--picture-card,
        .el-upload-list__item,
        .el-upload-list__item {
          width: 120px;
          height: 100px;
          background: #eee;
        }
      }
      &.upload3 {
        padding-left: 70px;
        margin-bottom: 18px;
      }
      &.record {
        padding-left: 70px;
      }
      &:last-of-type {
        margin-top: 10px;
        // margin-bottom: ;
        display: flex;
        justify-content: center;
        .el-button {
          width: 112px;
          height: 32px;
          padding: 0;
          text-align: center;
          line-height: 32px;
          font-size: 14px;
          margin-right: 20px;
        }
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner,
      .el-input__inner {
        width: 300px;
        font-size: 12px;
      }
      .el-date-editor .el-input__inner {
        padding-left: 15px;
      }
      .moreinfo {
        width: 100%;
        .el-input__inner,
        .el-textarea__inner {
          width: 760px;
        }
      }
    }
    .photo {
      display: block;
      float: right;
      padding-left: 0px !important;
      margin-right: 232px;
      margin-left: 0;
      margin-bottom: 0;
      margin-top: 30px;
      .el-form-item__label {
        width: 50px !important;
      }
      .el-upload--picture-card {
        width: 100px;
        height: 136px;
      }
      .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 136px;
        line-height: 136px;
        text-align: center;
        background: #eee;
      }
      .avatar {
        width: 100px;
        height: 136px;
        display: block;
      }
    }
  }
</style>
